import Vue from 'vue';
import {
  SAVE_QUOTES,
} from '@/store/mutation-types';

const expressquote = {
  state: {
    quotes: [
      {
        id: 238,
        number: '6000000001',
        creationDate: '01/06/2019 18:00',
        startDate: '10/06/2019 18:00',
        closingDate: '30/06/2019 18:00',
        creatorUser: 'Francisco G.',
        status: 'Closed',
        items: [],
        summary: {
          invited: 2,
          revised: 0,
          bids: 0,
          rejected: 0,
        },
        confirm: {
          availability: 2,
          uom: 'KG',
          deliveryDate: '2019/03/20',
          deliveryLocation: 'Singapur',
          differentDate: true,
          timeResponse: '19:00',
        },
        match: 3,
      },
      {
        id: 239,
        number: '6000000002',
        creationDate: '08/08/2019 18:00',
        startDate: '08/08/2019 18:00',
        closingDate: '30/08/2019 18:00',
        creatorUser: 'Francisco G.',
        status: 'Published',
        items: [],
        summary: {
          invited: 1,
          revised: 1,
          bids: 0,
          rejected: 0,
        },
        confirm: {
          availability: 1000,
          uom: 'KG',
          deliveryDate: '2019/04/20',
          deliveryLocation: 'Busan',
          differentDate: true,
          timeResponse: '16:00',
        },
        match: 2,
      },
    ],
  },
  mutations: {
    ADD_ITEM_EXPRESS_QUOTE: (state, data) => {
      state.quotes.push(data);
      Vue.ls.set(SAVE_QUOTES, state);
    },
  },
  actions: {
    addExpressQuote({ commit }, quote) {
      commit('ADD_ITEM_EXPRESS_QUOTE', quote);
    },
  },
  getters: {
    quotesInfo: state => state.quotes,
  },
};

export default expressquote;



// WEBPACK FOOTER //
// ./src/store/modules/express-quote.js